import React from 'react';
import { useAutoDataGridContext } from '../../auto-data-grid';
import { Button } from '@fox/atoms';

export function ResetLocalView() {
	const { resetLocalStorage, id } = useAutoDataGridContext();
	const localStorageView = localStorage.getItem(`TW_${id}_view`);
	if (!localStorageView) return null;
	return <Button onClick={resetLocalStorage}>Reset View</Button>;
}
